import { del, get, jsonParser, post, put } from "./Client";

export const getDrink = (drink) => 
  get(`/drinks/${drink.id}`).then(jsonParser);

export const searchDrinks = (query, all = false, page = 0, sort = "createdDate", order = "ASC") =>
  get(`/drinks?query=${query}&all=${all ? "true" : "false"}&page=${page}&sort=${sort}&order=${order}`)
  .then(jsonParser);

export const createDrink = (drink) =>
  post("/drinks", { body: drink }).then(jsonParser);

export const updateDrink = (drink) =>
  put(`/drinks/${drink.id}`, { body: drink }).then(jsonParser);

export const deleteDrink = (drink) => 
  del(`/drinks/${drink.id}`).then(jsonParser);

export const getAllDrinks = (sort = "nameBr", order = "ASC") => 
  get(`/drinks/all?sort=${sort}&order=${order}`).then(jsonParser);